import { QuestionVisualizationEnum } from '@keyops-cep/api-client';

// DataTable visualization allow-list
export const DATA_TABLE_VISUALIZATIONS = new Set<string>([
  QuestionVisualizationEnum.StackedBarChart,
  QuestionVisualizationEnum.MultiSelectGrid,
  QuestionVisualizationEnum.MaxDiff,
]);

// Edit visualization allow-list
export const EDITABLE_VISUALIZATIONS = new Set<string>([
  QuestionVisualizationEnum.StackedBarChart,
  QuestionVisualizationEnum.Histogram,
  QuestionVisualizationEnum.HorizontalHistogram,
  QuestionVisualizationEnum.HorizontalBarGraphOfAverages,
  QuestionVisualizationEnum.MaxDiff,
  QuestionVisualizationEnum.Distribution,
]);
